"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyCategory = void 0;
exports.emptyCategory = {
    title: "",
    description: "",
    parentId: 1,
};
//# sourceMappingURL=empty-category.js.map